<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-account-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewAccount',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewAccountView: () => import('../components/core/ViewAccountView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
